import { render, staticRenderFns } from "./LabelLayoutEditElectronProperties.vue?vue&type=template&id=6b5c27c1"
import script from "./LabelLayoutEditElectronProperties.vue?vue&type=script&lang=ts"
export * from "./LabelLayoutEditElectronProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5c27c1')) {
      api.createRecord('6b5c27c1', component.options)
    } else {
      api.reload('6b5c27c1', component.options)
    }
    module.hot.accept("./LabelLayoutEditElectronProperties.vue?vue&type=template&id=6b5c27c1", function () {
      api.rerender('6b5c27c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout/LabelLayoutEditElectronProperties.vue"
export default component.exports